import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage } = useTranslation();

  const languages = {
    en: { flag: 'gb', label: 'English' },
    tr: { flag: 'tr', label: 'Türkçe' },
    ru: { flag: 'ru', label: 'Русский' },
    fr: { flag: 'fr', label: 'Français' },
    it: { flag: 'it', label: 'Italiano' },
    es: { flag: 'es', label: 'Español' },
    nl: { flag: 'nl', label: 'Nederlands' },
    pt: { flag: 'pt', label: 'Português' },
    pl: { flag: 'pl', label: 'Polski' },
    de: { flag: 'de', label: 'Deutsch' },
  };

  const currentLang = currentLanguage || 'en';
  const languageInfo = languages[currentLang];

  return (
    <div className="language-dropdown">
      <button className="language-btn">
        <span className={`flag-icon flag-${languageInfo.flag}`}></span>
        <span style={{
          fontWeight: 400,
          fontSize: '15px',
        }} className="selected-language">{languageInfo.label}</span>
        <i className="fas fa-chevron-down"></i>
      </button>
      <div className="language-dropdown-content">
        {Object.entries(languages).map(([code, { flag, label }]) => (
          <a
            href="javascript:void(0)"
            key={label}
            onClick={(e) => {
              e.preventDefault();
              changeLanguage(code);
            }}
            className={currentLang === code ? 'selected' : ''}
          >
            <span className={`flag-icon flag-${flag}`}></span>
            {label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
